// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"754":"17d60f8f","1347":"4d997065","2665":"fa6690c0","3905":"bfe99496","4547":"ee7241fe","5158":"c2fbd056","5376":"35264f35","5479":"8dee5da3","5571":"122b7cc9","6160":"cd374e39","6271":"dccdd8e2","6306":"976a46eb","8842":"bc5f493b","9355":"b86037d4"}[chunkId] + ".chunk.js";
};